<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-form-item label="" class="query-form-item">
                    <el-button type="primary" icon="el-icon-back" @click="goBackList" size="mini"></el-button>
                </el-form-item>

                <el-form-item label="状态：" class="query-form-item">
                    <el-select v-model="query.status" placeholder="状态" size="mini">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="建库导入完成" :value="3"></el-option>
                        <el-option label="获取基础信息中" :value="4"></el-option>
                        <el-option label="获取基础信息完成" :value="5"></el-option>
                        <el-option label="获取1688链接中" :value="6"></el-option>
                        <el-option label="重新获取1688链接中" :value="7"></el-option>
                        <el-option label="成本分析待解析" :value="0"></el-option>
                        <el-option label="成本分析解析中" :value="1"></el-option>
                        <el-option label="成本分析完成" :value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="销售国家: " class="query-form-item" prop="state">
                    <el-select v-model="query.category_state" style="width: 150px;" size="mini" filterable>
                        <el-option v-for="item in $common.us_arr" :key="item.us" :label="item.title" :value="item.us" :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()"
                                          style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN:" class="query-form-item">
                    <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="标题：">
                    <el-input style="width: 200px;" clearable v-model="query.title"
                              placeholder="请输入标题" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="运输模式：" class="query-form-item">
                    <el-select v-model="query.deliver_mode" placeholder="请选择" size="mini" filterable>
                        <el-option :label="item.label" :value="item.value" v-for="item in $common.deliverModeArr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="季节：" class="query-form-item">
                    <el-select v-model="query.season" placeholder="请选择" size="mini" filterable>
                        <el-option :label="item.label" :value="item.value" v-for="item in $common.seasonArr"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="运费差:" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_freight_difference"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_freight_difference"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="重(g):" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_weight"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_weight"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="利润:" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_early_profit"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_early_profit"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>
                <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
            </el-form-item>

        </el-form>
        <el-table v-loading="loading" :data="list" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange" :height="tableHeight"
                  border @sort-change="handleSortChange">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ statusObj[scope.row.status] }}</div>
                </template>
            </el-table-column>
            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="(scope.row.category_state || '').toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="类目" min-width="400" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>
            <el-table-column label="销售价格" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.selling_price }}</div>
                </template>
            </el-table-column>
            <el-table-column
                width="110"
                align="center"
                label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上架时间" width="140" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.listed_since }}</div>
                </template>
            </el-table-column>

            <el-table-column label="品牌" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="评分" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating }}</div>
                </template>
            </el-table-column>

            <el-table-column label="评论数" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating_count }}</div>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>


            <el-table-column label="类目树" min-width="180" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category_tree }}</div>
                </template>
            </el-table-column>

            <el-table-column label="子类目" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.categories_str }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.ali_pic_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="1688产品标题" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="退货率" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ parseFloat((scope.row.refund_rate || 0) * 100).toFixed(2) }}%</div>
                </template>
            </el-table-column>

            <el-table-column label="是否季节性" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="季节" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.season }}</div>
                </template>
            </el-table-column>

            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                            scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="fba费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.fba_fees }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运费单价/kg" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_unit_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运输模式" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费差" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_difference }}</div>
                </template>
            </el-table-column>

            <el-table-column label="平台佣金" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.platform_commission }}</div>
                </template>
            </el-table-column>
            <el-table-column label="亚马逊物流配送费" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.delivery_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="退货费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.refund_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Vat税费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.vat_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月仓储费" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月仓储费" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="美国旺季差额" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.us_peak_season_balance }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格(免税)" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1-9月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月投资回报率" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['early_investment_return_rate'] ? accMul(scope.row['early_investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月投资回报率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['late_investment_return_rate'] ? accMul(scope.row['late_investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="利润率(含税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(免税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-'}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="detailFunc(scope.row)">详情</el-button>
                    <!--                    <el-button style="margin: 5px 0 5px 10px" size="mini" @click="goBackFunc(scope.row)">回退</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :current-page="query.page"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="display: flex;justify-content: end;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <detail-preview ref="detailPreview"></detail-preview>

    </div>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import ChildInfoModal from './childInfoModal.vue'
import DetailPreview from '@/views/warehouse/detailPreview.vue'
import {
    manager_build_selection_task_list_detail,
    manager_cost_analysis_manager_purchase_finish_list, manager_index_get_developer_list,
    manager_index_get_operator_list, master_index_manager_cost_analysis_details
} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {DetailPreview, ChildInfoModal},
    data() {
        return {
            tableHeight: null,
            managerAnalysisList: [],
            developerList: [],
            list: [],
            loading: false,
            statusObj: {
              3: '建库导入完成',
              4: '获取基础信息中',
              5: '获取基础信息完成',
              6: '获取1688链接中',
              7: '重新获取1688链接中',
              0: '成本分析待解析',
              1: '成本分析解析中',
              2: '成本分析完成',
            },
            query: {
                title: '',
                status: '',
                developer_id: '',
                operation_id: '',
                category_state: '',
                asin: '',
                deliver_mode: '',
                season: undefined,
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_early_profit: undefined,
                max_early_profit: undefined,
                page: 1,
                limit: 10,
                total: 0,
            },
            childInfo: {},
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
        }
    },
    mounted() {
        this.getManagerAnalysisList()
        this.getList()
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    computed: {
        showBack() {
            return this.$checkPermission('admin/cost_analysis/personal/return_from_purchase_finish_list')
        },
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        subLibraryDetailInfo: {
            type: Object,
            default: {}
        },
    },
    methods: {
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        goBackList() {
            this.query = {
                status: '',
                operation_id: '',
                developer_id: '',
                category_state: '',
                asin: '',
                deliver_mode: '',
                season: undefined,
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_early_profit: undefined,
                max_early_profit: undefined,
                page: 1,
                limit: 10,
                total: 0,
            }
            this.list = []
            this.$emit('goBackList')
        },
        goBackFunc(data){
            api.cost_analysis_personal_return_from_purchase_finish_list({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('回退成功')
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        //重置
        onReset() {
            this.query = {
                title: '',
                status: '',
                operation_id: '',
                developer_id: '',
                category_state: '',
                asin: '',
                deliver_mode: '',
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_early_profit: undefined,
                max_early_profit: undefined,
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
            this.$refs.detailPreview.funcType = 1
        },
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        chooseItem(data) {
            this.$emit('choose1688Info', data)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        getList() {
            this.loading = true
            api.master_index_manager_cost_analysis_details({...this.query, id: this.subLibraryDetailInfo.id}).then(res => {
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total || 0
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        getManagerAnalysisList(){
            api.manager_index_get_operator_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.developerList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>


